module.exports = {
	"config": {
		"siteTitle": "John Morris.",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {
				"title": "oops"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "creating-themeable-websites-using-currentcolor.md",
				"ext": "md",
				"name": "creating-themeable-websites-using-currentcolor",
				"extname": ".md",
				"basename": "creating-themeable-websites-using-currentcolor.md",
				"dirname": "blog",
				"stem": "creating-themeable-websites-using-currentcolor",
				"path": "blog/creating-themeable-websites-using-currentcolor.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/creating-themeable-websites-using-currentcolor.md",
				"isAbsolute": false
			},
			"requirePath": "blog/creating-themeable-websites-using-currentcolor.md",
			"path": "/blog/creating-themeable-websites-using-currentcolor/",
			"data": {
				"title": "Dynamically theme-able websites using CSS currentColor",
				"date": "2016-7-3",
				"category": "CSS, Outfit"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "css-generators.md",
				"ext": "md",
				"name": "css-generators",
				"extname": ".md",
				"basename": "css-generators.md",
				"dirname": "blog",
				"stem": "css-generators",
				"path": "blog/css-generators.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/css-generators.md",
				"isAbsolute": false
			},
			"requirePath": "blog/css-generators.md",
			"path": "/blog/css-generators/",
			"data": {
				"title": "5 handy css generators",
				"date": "2015-3-22",
				"layout": "blog",
				"category": "CSS"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "im-kind-of-sorry.md",
				"ext": "md",
				"name": "im-kind-of-sorry",
				"extname": ".md",
				"basename": "im-kind-of-sorry.md",
				"dirname": "blog",
				"stem": "im-kind-of-sorry",
				"path": "blog/im-kind-of-sorry.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/im-kind-of-sorry.md",
				"isAbsolute": false
			},
			"requirePath": "blog/im-kind-of-sorry.md",
			"path": "/blog/im-kind-of-sorry/",
			"data": {
				"title": "I'm Sorry (Kind of)",
				"date": "2015-9-8",
				"category": "User Experience"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "responsive-grids-with-nth-child.md",
				"ext": "md",
				"name": "responsive-grids-with-nth-child",
				"extname": ".md",
				"basename": "responsive-grids-with-nth-child.md",
				"dirname": "blog",
				"stem": "responsive-grids-with-nth-child",
				"path": "blog/responsive-grids-with-nth-child.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/responsive-grids-with-nth-child.md",
				"isAbsolute": false
			},
			"requirePath": "blog/responsive-grids-with-nth-child.md",
			"path": "/blog/responsive-grids-with-nth-child/",
			"data": {
				"title": "Flexbox style grids with nth-child Magic.",
				"date": "2015-4-9",
				"layout": "blog",
				"category": "CSS"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "vmin-and-vmax-in-ie.md",
				"ext": "md",
				"name": "vmin-and-vmax-in-ie",
				"extname": ".md",
				"basename": "vmin-and-vmax-in-ie.md",
				"dirname": "blog",
				"stem": "vmin-and-vmax-in-ie",
				"path": "blog/vmin-and-vmax-in-ie.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/vmin-and-vmax-in-ie.md",
				"isAbsolute": false
			},
			"requirePath": "blog/vmin-and-vmax-in-ie.md",
			"path": "/blog/vmin-and-vmax-in-ie/",
			"data": {
				"title": "Using vmin and vmax in ie",
				"date": "2015-9-9",
				"category": "Javascript",
				"layout": "blog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "vsco-image-filters-with-css.md",
				"ext": "md",
				"name": "vsco-image-filters-with-css",
				"extname": ".md",
				"basename": "vsco-image-filters-with-css.md",
				"dirname": "blog",
				"stem": "vsco-image-filters-with-css",
				"path": "blog/vsco-image-filters-with-css.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/blog/vsco-image-filters-with-css.md",
				"isAbsolute": false
			},
			"requirePath": "blog/vsco-image-filters-with-css.md",
			"path": "/blog/vsco-image-filters-with-css/",
			"data": {
				"title": "Recreating VSCOcam image filters with CSS blend modes",
				"date": "2016-8-23",
				"category": "CSS"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contact.md",
				"ext": "md",
				"name": "contact",
				"extname": ".md",
				"basename": "contact.md",
				"dirname": "",
				"stem": "contact",
				"path": "contact.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/contact.md",
				"isAbsolute": false
			},
			"requirePath": "contact.md",
			"path": "/contact/",
			"data": {
				"title": "Say Hello"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "cv.js",
				"ext": "js",
				"name": "cv",
				"extname": ".js",
				"basename": "cv.js",
				"dirname": "",
				"stem": "cv",
				"path": "cv.js",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/cv.js",
				"isAbsolute": false
			},
			"requirePath": "cv.js",
			"path": "/cv/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "project",
				"base": "hamburgler.md",
				"ext": "md",
				"name": "hamburgler",
				"extname": ".md",
				"basename": "hamburgler.md",
				"dirname": "project",
				"stem": "hamburgler",
				"path": "project/hamburgler.md",
				"absolute": "/Users/John/Documents/work/_personal/gatsby-test/project/hamburgler.md",
				"isAbsolute": false
			},
			"requirePath": "project/hamburgler.md",
			"path": "/project/hamburgler/",
			"data": {
				"title": "Hamburgler - Deliciously simple mobile navigation 🍔",
				"layout": "blog"
			}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 368
 ** module chunks = 0
 **/